import { SelectField } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { useGetBaseRateOptions } from '../queries/useGetBaseRateOptions';
import { DetailsFieldName } from '../types';

interface Props {
    disabled?: boolean;
}

export const BaseRateField = ({ disabled = false }: Props) => {
    const { data, isFetching } = useGetBaseRateOptions();
    return (
        <SelectField
            name={DetailsFieldName.BaseRateId}
            options={data ?? []}
            label={lt('BaseRate')}
            loader={isFetching}
            disabled={disabled}
        />
    );
};
